import { Offcanvas } from "react-bootstrap";

const Canvas = ({ show, handleClose, title, body, className }) => {
  // CSS Inline Styles
  const styles = {
    defaultCanvas: {
      width: "70%",
      zIndex: 1060, // default Bootstrap z-index for moda
    },
    largeCanvas: {
      width: "85%",
      zIndex: 1060, // default Bootstrap z-index for moda
    },
    fullscreenCanvas: {
      width: "100%",
      maxWidth: "100vw",
      zIndex: 1060, // default Bootstrap z-index for moda
    },
  };

  // Tentukan className default jika tidak ada
  const appliedStyle =
    className === "large-canvas"
      ? styles.largeCanvas
      : className === "fullscreen-canvas"
      ? styles.fullscreenCanvas
      : styles.defaultCanvas;

  return (
    <Offcanvas 
      show={show} 
      onHide={handleClose} 
      placement="end" 
      style={appliedStyle}
      enforceFocus={false}
      autoFocus={false}
      restoreFocus={false}
      scroll={true}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>{body}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default Canvas;
